<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <section id="ngx-datatable-kitchen-sink">
      <!-- <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            {{ 'MENU.DASHBOARD.PRIVACY_POLICY' | translate }}
          </h4>
        </div>
        <div class="card-body">
          <p class="card-text">
            {{ 'MENU.DASHBOARD.PRIVACY_POLICY_LIST' | translate }}
          </p>
        </div>
      </div> -->

      <div class="privacy-card" *ngFor="let item of arrCoupons">

        <!-- ===== HEADER ===== -->
        <div class="privacy-header d-flex justify-content-between align-items-center mb-2">

          <!-- ===== TITLE ===== -->
          <div class="privacy-title-wrapper">

            <!-- VIEW MODE -->
            <h2 *ngIf="!item.isEditing" class="privacy-title">
              {{ lang === 'ar' ? item.title_ar : item.title_en }}
            </h2>

            <!-- EDIT MODE - AR -->
            <input
              *ngIf="item.isEditing && lang === 'ar'"
              type="text"
              class="form-control privacy-title-input"
              [(ngModel)]="item.title_ar"
              name="title_ar_{{item.id}}"
            />

            <!-- EDIT MODE - EN -->
            <input
              *ngIf="item.isEditing && lang === 'en'"
              type="text"
              class="form-control privacy-title-input"
              [(ngModel)]="item.title_en"
              name="title_en_{{item.id}}"
            />

          </div>

          <!-- ===== ACTIONS ===== -->
          <div class="privacy-actions">
            <button
              *ngIf="!item.isEditing"
              class="btn btn-sm btn-outline-primary"
              (click)="enableEdit(item)">
              {{ 'MENU.DASHBOARD.EDIT' | translate }}
            </button>

            <ng-container *ngIf="item.isEditing">
              <button
                class="btn btn-sm btn-success me-1"
                (click)="submitEdit(item)">
                {{ 'MENU.DASHBOARD.SAVE' | translate }}
              </button>

              <button
                class="btn btn-sm btn-outline-secondary"
                (click)="cancelEdit(item)">
                {{ 'MENU.DASHBOARD.CANCEL' | translate }}
              </button>
            </ng-container>
          </div>
        </div>

        <div class="divider my-2"></div>

        <!-- ===== VIEW MODE CONTENT ===== -->
        <div
          *ngIf="!item.isEditing"
          class="privacy-content"
          [innerHTML]="formatContent(lang === 'ar' ? item.content_ar : item.content_en)">
        </div>

        <!-- ===== EDIT MODE CONTENT ===== -->

        <!-- AR -->
        <textarea
          *ngIf="item.isEditing && lang === 'ar'"
          class="form-control mt-2"
          rows="6"
          [(ngModel)]="item.content_ar"
          name="content_ar_{{item.id}}">
        </textarea>

        <!-- EN -->
        <textarea
          *ngIf="item.isEditing && lang === 'en'"
          class="form-control mt-2"
          rows="6"
          [(ngModel)]="item.content_en"
          name="content_en_{{item.id}}">
        </textarea>

      </div>
    </section>
  </div>
</div>
